import { RootState } from 'store';
import { ContragentState } from 'types';

const selectContragents = (state: RootState): ContragentState => state.contragent;
export default selectContragents;
